import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	variableBox: {
		marginBottom: 16,
		display: "flex",
		alignItems: "center",
		"& svg": {
			width: 13,
			height: 13,
			margin: "2.5px 0px 0px 4px;"
		}
	},
	bracketRight: {
		border: "1px solid",
		borderRadius: 8,
		borderRight: "inherit",
		padding: "18px 20px",
		borderColor: colors.gray[400],
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[100]),
		color: colors.gray[400],
		fontWeight: 400,
		fontSize: 16
	},
	bracketLeft: {
		borderRadius: 8,
		borderLeft: "inherit",
		padding: "18px 20px",
		borderColor: colors.gray[400],
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[100]),
		border: "1px solid",
		color: colors.gray[400],
		fontWeight: 400,
		fontSize: 16
	},
	inputResetPadding: {
		"& div": {
			padding: 0,
			maxWidth: 553,
			borderRadius: 8
		},
		"& input": {
			borderRadius: 8,
			paddingLeft: 12,
			cursor: "not-allowed"
		},
		maxWidth: 584
	},
	labelOutlinedStyle: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		padding: "0px 4px"
	},
	alterationAlert: {
		display: "contents",
		"& .alert-content": {
			margin: "0px 10px"
		}
	},
	selectedGroupPlaceholder: {
		color: colors.gray[400]
	}
}))

export default useStyles
